export const normalizeHistoric = historic => {
    const historicData = [...historic];
    return [...historicData];
};
